<template>
  <v-select
    hide-details="auto"
    :items="status"
    v-model="filterDatas.purchasestatus"
    item-text="name"
    item-value="id"
    label="Status"
    outlined
    clearable
    dense
    @change="emitInput(filterDatas.purchasestatus)"
  ></v-select>
</template>
<script>
import { mapState } from 'vuex';

export default {
  props: {
    clear: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    status: [
      {
        id: 'Pending',
        name: 'Pending',
      },
      {
        id: 'Completed',
        name: 'Completed',
      },
      {
        id: 'Canceled',
        name: 'Cancelled',
      },
    ],
    selectStatus: null,
  }),
  computed: {
    ...mapState(['filterDatas']),
  },
  methods: {
    emitInput(data) {
      this.$store.commit('UPDATE_PURCHASE_STATUS_FILTER', data);

      this.$emit('input', this.filterDatas.purchasestatus);
    },
  },
  watch: {
    clear: {
      handler(val) {
        this.selectStatus = null;
      },
      deep: true,
    },
  },
  created() {
    this.$emit('input', this.filterDatas.purchasestatus);
  },
};
</script>
